import React from 'react';
import { RendererContext } from '../../context';

export const useIsConfluenceModule = (): boolean => {
	const { extensionType } = React.useContext(RendererContext);
	return extensionType === 'xen:macro' || !!extensionType?.startsWith('confluence');
};
